// Category display/sort order: most actionable first (Support → Improve → Great).
export const CATEGORY_EVALUATION_ORDER = {
    Support: 0,
    Improve: 1,
    Great: 2,
};
// Unknown/missing evaluations sort last.
export function getCategoryEvaluationOrder(evaluation) {
    return (CATEGORY_EVALUATION_ORDER[evaluation] ??
        Number.POSITIVE_INFINITY);
}
//# sourceMappingURL=categoryEvaluation.js.map